
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7651"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7651"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bBXum", function(module, exports) {

$parcel$export(module.exports, "Client", () => $9efcf42537b67d79$export$1f2bb630327ac4b6);
/* eslint no-console: 0 */ 
var $7etJZ = parcelRequire("7etJZ");

var $93wdc = parcelRequire("93wdc");
const $9efcf42537b67d79$var$DINGQUE_STORAGE_PREFIX = 'mjlab.dingque.';
class $9efcf42537b67d79$export$1f2bb630327ac4b6 extends (0, $93wdc.BaseClient) {
    constructor(){
        super(), this.bloodActionSeq = Date.now(), this.gbActionSeq = Date.now(), this.pendingActionById = new Map(), this.localCommittedDingqueSuit = null, this.ackedDingqueSuit = null, this.lastAutoResendDingqueAtMs = 0, this.lastAutoResendDingqueSuit = null, this.seat = null, this.seatPlayers = new Array(4).fill(null);
        // Make sure match is first, as it triggers reorganization of slots and things.
        this.match = new $9efcf42537b67d79$export$fb8073518f34e6ec('match', this, {
            sendOnConnect: true
        }), this.seats = new $9efcf42537b67d79$export$fb8073518f34e6ec('seats', this, {
            unique: 'seat'
        });
        this.things = new $9efcf42537b67d79$export$fb8073518f34e6ec('things', this, {
            unique: 'slotName',
            sendOnConnect: true
        });
        this.nicks = new $9efcf42537b67d79$export$fb8073518f34e6ec('nicks', this, {
            perPlayer: true
        });
        this.avatars = new $9efcf42537b67d79$export$fb8073518f34e6ec('avatars', this, {
            perPlayer: true
        });
        this.mouse = new $9efcf42537b67d79$export$fb8073518f34e6ec('mouse', this, {
            rateLimit: 100,
            perPlayer: true
        });
        this.sound = new $9efcf42537b67d79$export$fb8073518f34e6ec('sound', this, {
            ephemeral: true
        });
        this.dice = new $9efcf42537b67d79$export$fb8073518f34e6ec('dice', this, {
            ephemeral: true
        });
        this.blood = new $9efcf42537b67d79$export$fb8073518f34e6ec('blood', this);
        this.bloodAction = new $9efcf42537b67d79$export$fb8073518f34e6ec('bloodAction', this, {
            ephemeral: true,
            perPlayer: true
        });
        this.gb = new $9efcf42537b67d79$export$fb8073518f34e6ec('gb', this);
        this.gbAction = new $9efcf42537b67d79$export$fb8073518f34e6ec('gbAction', this, {
            ephemeral: true,
            perPlayer: true
        });
        this.tileFacePublic = new $9efcf42537b67d79$export$fb8073518f34e6ec('tileFacePublic', this);
        this.tileFaceSelf = new $9efcf42537b67d79$export$fb8073518f34e6ec('tileFaceSelf', this);
        this.seats.on('update', this.onSeats.bind(this));
        this.blood.on('update', this.onBlood.bind(this));
        this.on('actionAck', this.onActionAck.bind(this));
        this.on('connectionState', (state)=>{
            if (state === 'ready') this.maybeResendDingqueAction();
        });
    }
    sendBloodAction(action) {
        if (this.isAuthoritative()) {
            const gameId = this.gameId();
            if (!gameId || !this.actionsReady()) return null;
            const now = Date.now();
            const seq = now <= this.bloodActionSeq ? this.bloodActionSeq + 1 : now;
            this.bloodActionSeq = seq;
            // ACTION actionId is unique across reconnects for this game/user. Blood & Guobiao actions
            // share the server-side ledger, so prefix independent counters to avoid collisions.
            const actionId = `b-${seq}`;
            this.pendingActionById.set(actionId, action);
            if (action.kind === 'dingque') {
                // 服务端在盲选阶段不会立即公开 dingque；本地先记住自己的选择用于 HUD 展示。
                this.localCommittedDingqueSuit = action.suit;
                // 先落盘，覆盖“提交后快速重连但 ACK 尚未返回”的窗口。
                this.writeStoredDingqueSuit(action.suit);
            }
            this.send({
                type: 'ACTION',
                gameId: gameId,
                actionId: actionId,
                action: action
            });
            return actionId;
        }
        const now = Date.now();
        const seq = now <= this.bloodActionSeq ? this.bloodActionSeq + 1 : now;
        this.bloodActionSeq = seq;
        this.bloodAction.set(this.playerId(), {
            seq: seq,
            action: action
        });
        return String(seq);
    }
    sendGbAction(action) {
        if (this.isAuthoritative()) {
            const gameId = this.gameId();
            if (!gameId || !this.actionsReady()) return null;
            const now = Date.now();
            const seq = now <= this.gbActionSeq ? this.gbActionSeq + 1 : now;
            this.gbActionSeq = seq;
            // See sendBloodAction(): the game/user action ledger is shared across game variants.
            const actionId = `g-${seq}`;
            this.pendingActionById.set(actionId, action);
            this.send({
                type: 'ACTION',
                gameId: gameId,
                actionId: actionId,
                action: action
            });
            return actionId;
        }
        const now = Date.now();
        const seq = now <= this.gbActionSeq ? this.gbActionSeq + 1 : now;
        this.gbActionSeq = seq;
        this.gbAction.set(this.playerId(), {
            seq: seq,
            action: action
        });
        return String(seq);
    }
    localDingqueSuit() {
        return this.localCommittedDingqueSuit;
    }
    dingqueStorageKey() {
        const gameId = this.gameId();
        const playerId = this.playerId();
        if (!gameId || !playerId) return null;
        return `${$9efcf42537b67d79$var$DINGQUE_STORAGE_PREFIX}${gameId}.${playerId}`;
    }
    readStoredDingqueSuit() {
        const key = this.dingqueStorageKey();
        if (!key) return null;
        try {
            const raw = localStorage.getItem(key);
            if (raw === 'm' || raw === 'p' || raw === 's') return raw;
        } catch  {
        // ignore
        }
        return null;
    }
    writeStoredDingqueSuit(suit) {
        const key = this.dingqueStorageKey();
        if (!key) return;
        try {
            if (suit === null) localStorage.removeItem(key);
            else localStorage.setItem(key, suit);
        } catch  {
        // ignore
        }
    }
    resolveMyPlayerState(state) {
        if (!state) return null;
        const mySeat = this.seat;
        if (mySeat !== null && mySeat >= 0 && mySeat <= 3) return state.players?.[mySeat] ?? null;
        const myPlayerId = this.playerId();
        for (const s of [
            0,
            1,
            2,
            3
        ]){
            const ps = state.players?.[s] ?? null;
            if (ps?.playerId === myPlayerId) return ps;
        }
        return null;
    }
    authoritativeDingqueSuit() {
        const state = this.blood.get(0);
        const me = this.resolveMyPlayerState(state);
        const suit = me?.dingque ?? null;
        if (suit === 'm' || suit === 'p' || suit === 's') return suit;
        return this.ackedDingqueSuit;
    }
    onSeats() {
        this.seat = null;
        this.seatPlayers.fill(null);
        for (const [playerId, seatInfo] of this.seats.entries()){
            if (playerId === this.playerId()) this.seat = seatInfo.seat;
            if (seatInfo.seat !== null) this.seatPlayers[seatInfo.seat] = playerId;
        }
    }
    onBlood() {
        const state = this.blood.get(0);
        if (!state) {
            this.localCommittedDingqueSuit = null;
            this.ackedDingqueSuit = null;
            return;
        }
        if (state.phase === 'swap3') {
            this.localCommittedDingqueSuit = null;
            this.ackedDingqueSuit = null;
            this.writeStoredDingqueSuit(null);
            return;
        }
        const me = this.resolveMyPlayerState(state);
        if (!me) return;
        if (me?.dingque) {
            this.ackedDingqueSuit = me.dingque;
            this.localCommittedDingqueSuit = me.dingque;
            this.writeStoredDingqueSuit(me.dingque);
            return;
        }
        if (state.phase === 'dingque' && me.dingqueReady === true) {
            const stored = this.readStoredDingqueSuit();
            if (stored) {
                this.ackedDingqueSuit = stored;
                this.localCommittedDingqueSuit = stored;
            }
        }
        this.maybeResendDingqueAction();
    }
    maybeResendDingqueAction() {
        if (!this.isAuthoritative() || !this.actionsReady()) return;
        const state = this.blood.get(0);
        if (!state || state.phase !== 'dingque') return;
        const me = this.resolveMyPlayerState(state);
        if (!me) return;
        if (me.dingqueReady === true || me.dingque !== null) return;
        const suit = this.localCommittedDingqueSuit ?? this.readStoredDingqueSuit();
        if (suit !== 'm' && suit !== 'p' && suit !== 's') return;
        const now = Date.now();
        // 防抖：避免在弱网/高频 update 下疯狂重发。
        if (this.lastAutoResendDingqueSuit === suit && now - this.lastAutoResendDingqueAtMs < 1500) return;
        this.lastAutoResendDingqueAtMs = now;
        this.lastAutoResendDingqueSuit = suit;
        this.sendBloodAction({
            kind: 'dingque',
            suit: suit
        });
    }
    onActionAck(ack) {
        const action = this.pendingActionById.get(ack.actionId) ?? null;
        if (!action) return;
        this.pendingActionById.delete(ack.actionId);
        if (action.kind !== 'dingque') return;
        if (ack.ok) {
            // 以服务端接受的 action 为准，修正连点/乱序造成的本地花色漂移。
            this.ackedDingqueSuit = action.suit;
            this.localCommittedDingqueSuit = action.suit;
            this.writeStoredDingqueSuit(action.suit);
            return;
        }
        // 断线重连竞态：可能重复补发已被服务端记录的定缺，服务端会回 already dingque 且不更新 blood。
        // 这类 ACK 失败不应清空本地/落盘花色，否则 HUD/UI 会丢失已选信息。
        if (String(ack.error ?? '').trim() === 'already dingque') return;
        const committed = this.authoritativeDingqueSuit();
        if (committed !== null) {
            this.localCommittedDingqueSuit = committed;
            return;
        }
        if (this.localCommittedDingqueSuit === action.suit) {
            this.localCommittedDingqueSuit = null;
            this.writeStoredDingqueSuit(null);
        }
    }
    bindLoginToken(loginToken) {
        const token = (loginToken ?? '').trim();
        if (!token) return;
        // Best-effort; server will ignore if not joined yet.
        this.send({
            type: 'BIND_USER',
            loginToken: token
        });
    }
    sendReplayLog(events) {
        if (!Array.isArray(events) || events.length === 0) return;
        this.send({
            type: 'REPLAY_LOG',
            events: events
        });
    }
    aiGetTemplates() {
        this.send({
            type: 'AI_TEMPLATES_GET'
        });
    }
    aiSaveTemplate(params) {
        this.send({
            type: 'AI_TEMPLATE_SAVE',
            mode: params.mode,
            template: params.template,
            setDefault: params.setDefault
        });
    }
    aiDeleteTemplate(templateId) {
        this.send({
            type: 'AI_TEMPLATE_DELETE',
            templateId: templateId
        });
    }
    aiSetDefaultTemplate(scene, templateId) {
        this.send({
            type: 'AI_TEMPLATE_SET_DEFAULT',
            scene: scene,
            templateId: templateId
        });
    }
    aiGetHistory(gameId) {
        this.send({
            type: 'AI_HISTORY_GET',
            gameId: gameId
        });
    }
    aiRecommend(params) {
        this.send({
            type: 'AI_RECOMMEND',
            ...params
        });
    }
    aiFollowup(params) {
        this.send({
            type: 'AI_FOLLOWUP',
            ...params
        });
    }
    aiPreview(params) {
        this.send({
            type: 'AI_PREVIEW_GET',
            ...params
        });
    }
    setBloodConfig(params) {
        this.send({
            type: 'BLOOD_CONFIG_SET',
            ...params
        });
    }
    setFriendConfig(params) {
        this.send({
            type: 'FRIEND_CONFIG_SET',
            ...params
        });
    }
    setGuobiaoConfig(params) {
        this.send({
            type: 'GUOBIAO_CONFIG_SET',
            ...params
        });
    }
}
class $9efcf42537b67d79$export$fb8073518f34e6ec {
    constructor(kind, client, options){
        this.map = new Map();
        this.pending = new Map();
        this.events = new (0, $7etJZ.EventEmitter)();
        this.intervalId = null;
        this.lastUpdate = 0;
        this.kind = kind;
        this.client = client;
        this.options = options ?? {};
        this.client.on('update', this.onUpdate.bind(this));
        this.client.on('connect', this.onConnect.bind(this));
        this.client.on('disconnect', this.onDisconnect.bind(this));
    }
    entries() {
        return this.map.entries();
    }
    get(key) {
        return this.map.get(key) ?? null;
    }
    update(localEntries) {
        if (!this.client.connected()) {
            for (const [key, value] of localEntries)if (value !== null) this.map.set(key, value);
            else this.map.delete(key);
            this.events.emit('update', localEntries, false);
        } else {
            const now = new Date().getTime();
            for (const [key, value] of localEntries)this.pending.set(key, value);
            if (!this.options.rateLimit || now > this.lastUpdate + this.options.rateLimit) this.sendPending();
        }
    }
    set(key, value) {
        this.update([
            [
                key,
                value
            ]
        ]);
    }
    on(what, handler) {
        this.events.on(what, handler);
    }
    onUpdate(entries, full) {
        if (full) this.map.clear();
        const localEntries = [];
        for (const [kind, key, value] of entries)if (kind === this.kind) {
            localEntries.push([
                key,
                value
            ]);
            if (value !== null) this.map.set(key, value);
            else this.map.delete(key);
        }
        if (full || localEntries.length > 0) {
            console.log(full ? 'full update' : 'update', this.kind, localEntries.length);
            this.events.emit('update', localEntries, full);
        }
    }
    onConnect(_game, isFirst) {
        if (isFirst) {
            if (this.options.unique) this.client.update([
                [
                    'unique',
                    this.kind,
                    this.options.unique
                ]
            ]);
            if (this.options.ephemeral) this.client.update([
                [
                    'ephemeral',
                    this.kind,
                    true
                ]
            ]);
            if (this.options.perPlayer) this.client.update([
                [
                    'perPlayer',
                    this.kind,
                    true
                ]
            ]);
            if (this.options.sendOnConnect) {
                const entries = [];
                for (const [key, value] of this.map.entries())entries.push([
                    this.kind,
                    key,
                    value
                ]);
                this.client.update(entries);
            }
        }
        if (this.options.rateLimit) this.intervalId = setInterval(this.sendPending.bind(this), this.options.rateLimit);
    }
    onDisconnect(game) {
        if (this.intervalId !== null) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        if (game && this.options.perPlayer) {
            const localEntries = [];
            for (const [key, value] of this.map.entries()){
                localEntries.push([
                    this.kind,
                    key,
                    null
                ]);
                if (key === game.playerId) localEntries.push([
                    this.kind,
                    'offline',
                    value
                ]);
            }
            this.onUpdate(localEntries, true);
        }
    }
    sendPending() {
        if (this.pending.size > 0) {
            const entries = [];
            for (const [k, v] of this.pending.entries())entries.push([
                this.kind,
                k,
                v
            ]);
            this.client.update(entries);
            this.lastUpdate = new Date().getTime();
            this.pending.clear();
        }
    }
}

});
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5440e9199a418654$var$R = typeof Reflect === 'object' ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === 'function' ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === 'function') $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("93wdc", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $38167fb08b74ea59$export$4f22f74eddb7716a);
/* eslint no-console: 0 */ 
var $7etJZ = parcelRequire("7etJZ");

var $crvyM = parcelRequire("crvyM");

var $8PAWz = parcelRequire("8PAWz");
const $38167fb08b74ea59$var$ACTION_DIAGNOSTIC_TIMEOUT_MS = 30000;
const $38167fb08b74ea59$var$ACTION_ACK_TIMEOUT_MS = 12000;
const $38167fb08b74ea59$var$HEARTBEAT_INTERVAL_MS = 10000;
const $38167fb08b74ea59$var$HEARTBEAT_TIMEOUT_MS = 30000;
function $38167fb08b74ea59$var$diagnosticNow() {
    return typeof performance !== 'undefined' && typeof performance.now === 'function' ? performance.now() : Date.now();
}
function $38167fb08b74ea59$var$diagnosticsEnabled() {
    if (typeof window === 'undefined') return false;
    try {
        const query = new URLSearchParams(window.location.search).get('wsdiag');
        if (query === '1') return true;
        if (query === '0') return false;
        return window.localStorage.getItem('mjlab.wsDiagnostics') === '1';
    } catch  {
        return false;
    }
}
function $38167fb08b74ea59$var$utf8Bytes(value) {
    try {
        return new TextEncoder().encode(value).byteLength;
    } catch  {
        return value.length;
    }
}
function $38167fb08b74ea59$var$roundedMs(value) {
    return value === undefined ? undefined : Math.round(value * 100) / 100;
}
function $38167fb08b74ea59$var$logDiagnostic(event, fields) {
    if (!$38167fb08b74ea59$var$diagnosticsEnabled()) return;
    console.info(`[wsdiag] ${JSON.stringify({
        scope: 'client',
        event: event,
        at: Date.now(),
        ...fields
    })}`);
}
class $38167fb08b74ea59$export$4f22f74eddb7716a {
    constructor(){
        this.ws = null;
        this.game = null;
        this.events = new (0, $7etJZ.EventEmitter)();
        this.pending = null;
        this.connectedAt = null;
        this.actionDiagnostics = new Map();
        this.connectionStateValue = 'disconnected';
        this.reliableActions = new Map();
        this.awaitingFullSync = false;
        this.heartbeatTimer = null;
        this.heartbeatNonce = null;
        this.heartbeatSentAt = 0;
        this.heartbeatSeq = 0;
        this.events.setMaxListeners(50);
        this.localPlayerId = (0, $crvyM.getOrCreatePlayerId)();
        if (typeof document !== 'undefined') document.addEventListener('visibilitychange', ()=>{
            if (document.visibilityState === 'visible') this.checkConnectionHealth();
        });
    }
    new(url, options = {}) {
        this.clearReliableActions();
        this.connect(url, ()=>{
            const loginToken = (0, $8PAWz.getLoginToken)();
            this.send({
                type: 'NEW',
                playerId: this.localPlayerId,
                gameType: options.gameType,
                friendConfig: options.friendConfig,
                guobiaoConfig: options.guobiaoConfig,
                loginToken: loginToken ?? undefined
            });
        });
    }
    join(url, gameId, options = {}) {
        for (const [actionId, pending] of Array.from(this.reliableActions.entries()))if (pending.message.gameId !== gameId) this.forgetReliableAction(actionId);
        this.connect(url, ()=>{
            const loginToken = (0, $8PAWz.getLoginToken)();
            this.send({
                type: 'JOIN',
                gameId: gameId,
                playerId: this.localPlayerId,
                guobiaoConfig: options.guobiaoConfig,
                loginToken: loginToken ?? undefined
            });
        });
    }
    disconnect() {
        this.ws?.close();
    }
    connect(url, start) {
        if (this.ws) return;
        this.setConnectionState('connecting');
        const socket = new WebSocket(url);
        this.ws = socket;
        const connectingAt = $38167fb08b74ea59$var$diagnosticNow();
        socket.onopen = ()=>{
            if (this.ws !== socket) return;
            this.connectedAt = $38167fb08b74ea59$var$diagnosticNow();
            $38167fb08b74ea59$var$logDiagnostic('connection.open', {
                connectMs: $38167fb08b74ea59$var$roundedMs(this.connectedAt - connectingAt),
                extensions: socket.extensions || 'none'
            });
            this.startHeartbeat();
            start();
        };
        socket.onclose = (event)=>{
            if (this.ws !== socket) return;
            this.ws = null;
            this.finishClose(event);
        };
        socket.onerror = ()=>{
            if (this.ws !== socket) return;
            $38167fb08b74ea59$var$logDiagnostic('connection.error', {});
        };
        socket.onmessage = (event)=>{
            if (this.ws !== socket) return;
            const receivedAt = $38167fb08b74ea59$var$diagnosticNow();
            const raw = event.data;
            const message = JSON.parse(raw);
            const messageFields = {
                messageType: message.type,
                bytes: $38167fb08b74ea59$var$utf8Bytes(raw)
            };
            if (message.type === 'UPDATE') {
                messageFields.entryCount = message.entries.length;
                messageFields.full = message.full;
                const collectionCounts = {};
                for (const [kind] of message.entries)collectionCounts[kind] = (collectionCounts[kind] ?? 0) + 1;
                messageFields.collections = collectionCounts;
                const candidate = Array.from(this.actionDiagnostics.values()).find((item)=>item.firstUpdateAt === undefined);
                if (candidate) {
                    candidate.firstUpdateAt = receivedAt;
                    messageFields.candidateActionId = candidate.actionId;
                    messageFields.sendToFirstUpdateMs = $38167fb08b74ea59$var$roundedMs(receivedAt - candidate.sentAt);
                }
            } else if (message.type === 'ACTION_ACK') {
                messageFields.actionId = message.actionId;
                messageFields.ok = message.ok;
            }
            $38167fb08b74ea59$var$logDiagnostic('message.receive', messageFields);
            // console.log('recv', message);
            this.onMessage(message);
        };
    }
    on(what, handler) {
        this.events.on(what, handler);
    }
    transaction(func) {
        this.pending = [];
        try {
            func();
            if (this.pending !== null && this.pending.length > 0) {
                const filtered = this.filterOutgoingEntries(this.pending);
                if (filtered.length > 0) this.send({
                    type: 'UPDATE',
                    entries: filtered,
                    full: false
                });
            }
        } finally{
            this.pending = null;
        }
    }
    update(entries) {
        const filtered = this.filterOutgoingEntries(entries);
        if (filtered.length === 0) return;
        if (this.pending !== null) this.pending.push(...filtered);
        else this.send({
            type: 'UPDATE',
            entries: filtered,
            full: false
        });
    }
    send(message) {
        if (message.type === 'ACTION') {
            const actionId = String(message.actionId ?? '').trim();
            if (actionId && !this.reliableActions.has(actionId)) this.reliableActions.set(actionId, {
                message: message,
                lastSentAt: 0,
                ackTimer: null
            });
        }
        if (!this.open()) return;
        this.sendNow(message);
    }
    sendNow(message) {
        const socket = this.ws;
        if (!socket || socket.readyState !== WebSocket.OPEN) return;
        const data = JSON.stringify(message);
        if (message.type === 'ACTION') this.trackActionSend(message, data);
        try {
            socket.send(data);
        } catch  {
            if (message.type === 'ACTION') this.invalidateConnection('action_send_failed');
        }
    }
    trackActionSend(message, data) {
        const actionId = String(message.actionId ?? '').trim();
        if (!actionId) return;
        const reliable = this.reliableActions.get(actionId);
        if (reliable) {
            if (reliable.ackTimer !== null) window.clearTimeout(reliable.ackTimer);
            reliable.lastSentAt = Date.now();
            reliable.ackTimer = window.setTimeout(()=>{
                const current = this.reliableActions.get(actionId);
                if (!current || current.lastSentAt !== reliable.lastSentAt) return;
                $38167fb08b74ea59$var$logDiagnostic('action.ack-timeout', {
                    actionId: actionId,
                    actionKind: String(message.action?.kind ?? 'unknown'),
                    elapsedMs: Date.now() - current.lastSentAt
                });
                if (this.pageVisible()) this.invalidateConnection('action_ack_timeout');
            }, $38167fb08b74ea59$var$ACTION_ACK_TIMEOUT_MS);
        }
        if (!$38167fb08b74ea59$var$diagnosticsEnabled()) return;
        const sentAt = $38167fb08b74ea59$var$diagnosticNow();
        const actionKind = String(message.action?.kind ?? 'unknown');
        this.actionDiagnostics.set(actionId, {
            actionId: actionId,
            actionKind: actionKind,
            sentAt: sentAt
        });
        window.setTimeout(()=>{
            const item = this.actionDiagnostics.get(actionId);
            if (!item) return;
            $38167fb08b74ea59$var$logDiagnostic('action.timeout', {
                actionId: actionId,
                actionKind: item.actionKind,
                elapsedMs: $38167fb08b74ea59$var$roundedMs($38167fb08b74ea59$var$diagnosticNow() - item.sentAt),
                ackReceived: item.ackAt !== undefined,
                stateApplied: item.stateAppliedAt !== undefined,
                rendered: item.renderedAt !== undefined
            });
            this.actionDiagnostics.delete(actionId);
        }, $38167fb08b74ea59$var$ACTION_DIAGNOSTIC_TIMEOUT_MS);
        $38167fb08b74ea59$var$logDiagnostic('action.send', {
            actionId: actionId,
            actionKind: actionKind,
            bytes: $38167fb08b74ea59$var$utf8Bytes(data),
            bufferedAmount: this.ws?.bufferedAmount ?? 0
        });
    }
    markActionInteraction(actionId, interactionAt) {
        const item = this.actionDiagnostics.get(actionId);
        if (!item || !Number.isFinite(interactionAt)) return;
        item.interactionAt = interactionAt;
        $38167fb08b74ea59$var$logDiagnostic('action.interaction', {
            actionId: actionId,
            actionKind: item.actionKind,
            interactionToSendMs: $38167fb08b74ea59$var$roundedMs(item.sentAt - interactionAt)
        });
    }
    markActionStateApplied(actionId, source) {
        const item = this.actionDiagnostics.get(actionId);
        if (!item || item.stateAppliedAt !== undefined) return;
        item.stateAppliedAt = $38167fb08b74ea59$var$diagnosticNow();
        $38167fb08b74ea59$var$logDiagnostic('action.state-applied', {
            actionId: actionId,
            actionKind: item.actionKind,
            source: source,
            sendToStateAppliedMs: $38167fb08b74ea59$var$roundedMs(item.stateAppliedAt - item.sentAt),
            receiveToStateAppliedMs: item.firstUpdateAt === undefined ? undefined : $38167fb08b74ea59$var$roundedMs(item.stateAppliedAt - item.firstUpdateAt)
        });
    }
    markActionRendered(actionId) {
        const item = this.actionDiagnostics.get(actionId);
        if (!item || item.renderedAt !== undefined) return;
        item.renderedAt = $38167fb08b74ea59$var$diagnosticNow();
        $38167fb08b74ea59$var$logDiagnostic('action.rendered', {
            actionId: actionId,
            actionKind: item.actionKind,
            interactionToSendMs: item.interactionAt === undefined ? undefined : $38167fb08b74ea59$var$roundedMs(item.sentAt - item.interactionAt),
            sendToFirstUpdateMs: item.firstUpdateAt === undefined ? undefined : $38167fb08b74ea59$var$roundedMs(item.firstUpdateAt - item.sentAt),
            sendToStateAppliedMs: item.stateAppliedAt === undefined ? undefined : $38167fb08b74ea59$var$roundedMs(item.stateAppliedAt - item.sentAt),
            stateAppliedToRenderMs: item.stateAppliedAt === undefined ? undefined : $38167fb08b74ea59$var$roundedMs(item.renderedAt - item.stateAppliedAt),
            sendToAckMs: item.ackAt === undefined ? undefined : $38167fb08b74ea59$var$roundedMs(item.ackAt - item.sentAt),
            sendToRenderMs: $38167fb08b74ea59$var$roundedMs(item.renderedAt - item.sentAt),
            interactionToRenderMs: item.interactionAt === undefined ? undefined : $38167fb08b74ea59$var$roundedMs(item.renderedAt - item.interactionAt),
            ackOk: item.ackOk
        });
        if (item.ackAt !== undefined) this.actionDiagnostics.delete(actionId);
    }
    open() {
        return this.ws !== null && this.ws.readyState === WebSocket.OPEN;
    }
    connected() {
        return this.open() && this.game !== null;
    }
    connectionState() {
        return this.connectionStateValue;
    }
    actionsReady() {
        return this.connected() && this.connectionStateValue === 'ready';
    }
    playerId() {
        return this.game?.playerId ?? this.localPlayerId;
    }
    gameId() {
        return this.game?.gameId ?? null;
    }
    isAuthoritative() {
        return this.game?.authoritative ?? false;
    }
    setLocalGame(game) {
        this.game = game;
        this.awaitingFullSync = false;
        this.setConnectionState(game ? 'ready' : 'disconnected');
    }
    setConnectionState(state) {
        if (this.connectionStateValue === state) return;
        this.connectionStateValue = state;
        this.events.emit('connectionState', state);
    }
    filterOutgoingEntries(entries) {
        if (!this.isAuthoritative()) return entries;
        // In authoritative mode, the server is the only source of truth for these
        // collections. Clients must use ACTION instead.
        const forbidden = new Set([
            'match',
            'things',
            'blood',
            'bloodAction',
            'gb',
            'gbAction'
        ]);
        return entries.filter(([kind])=>!forbidden.has(kind));
    }
    finishClose(event, reason) {
        const now = $38167fb08b74ea59$var$diagnosticNow();
        this.stopHeartbeat();
        for (const pending of this.reliableActions.values()){
            if (pending.ackTimer !== null) window.clearTimeout(pending.ackTimer);
            pending.ackTimer = null;
        }
        $38167fb08b74ea59$var$logDiagnostic('connection.close', {
            code: event?.code,
            clean: event?.wasClean,
            reason: reason,
            connectedMs: this.connectedAt === null ? undefined : $38167fb08b74ea59$var$roundedMs(now - this.connectedAt),
            pendingActionCount: this.reliableActions.size
        });
        this.connectedAt = null;
        this.awaitingFullSync = false;
        const game = this.game;
        this.game = null;
        this.setConnectionState('disconnected');
        this.events.emit('disconnect', game);
    }
    pageVisible() {
        return typeof document === 'undefined' || document.visibilityState === 'visible';
    }
    startHeartbeat() {
        this.stopHeartbeat();
        this.heartbeatTimer = window.setInterval(()=>this.checkConnectionHealth(), $38167fb08b74ea59$var$HEARTBEAT_INTERVAL_MS);
        this.checkConnectionHealth();
    }
    stopHeartbeat() {
        if (this.heartbeatTimer !== null) window.clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
        this.heartbeatNonce = null;
        this.heartbeatSentAt = 0;
    }
    checkConnectionHealth() {
        if (!this.open() || !this.pageVisible()) return;
        const now = Date.now();
        const oldestAction = Array.from(this.reliableActions.values()).filter((item)=>item.lastSentAt > 0).sort((a, b)=>a.lastSentAt - b.lastSentAt)[0];
        if (oldestAction && now - oldestAction.lastSentAt >= $38167fb08b74ea59$var$ACTION_ACK_TIMEOUT_MS) {
            this.invalidateConnection('action_ack_timeout');
            return;
        }
        if (this.heartbeatNonce && now - this.heartbeatSentAt >= $38167fb08b74ea59$var$HEARTBEAT_TIMEOUT_MS) {
            this.invalidateConnection('heartbeat_timeout');
            return;
        }
        if (this.heartbeatNonce) return;
        this.heartbeatSeq += 1;
        this.heartbeatNonce = `h-${now}-${this.heartbeatSeq}`;
        this.heartbeatSentAt = now;
        this.sendNow({
            type: 'HEARTBEAT',
            nonce: this.heartbeatNonce
        });
    }
    invalidateConnection(reason) {
        const socket = this.ws;
        if (!socket) return;
        this.ws = null;
        socket.onopen = null;
        socket.onmessage = null;
        socket.onerror = null;
        socket.onclose = null;
        try {
            socket.close(4000, reason.slice(0, 120));
        } catch  {
        // The local connection state is still retired below.
        }
        this.finishClose(undefined, reason);
    }
    resendReliableActions() {
        const gameId = this.game?.gameId ?? null;
        if (!gameId) return;
        const pending = Array.from(this.reliableActions.values()).filter((item)=>item.message.gameId === gameId).sort((a, b)=>a.lastSentAt - b.lastSentAt);
        if (pending.length === 0) {
            this.setConnectionState('ready');
            return;
        }
        this.setConnectionState('recovering');
        for (const item of pending)this.sendNow(item.message);
    }
    forgetReliableAction(actionId) {
        const item = this.reliableActions.get(actionId);
        if (item && item.ackTimer !== null) window.clearTimeout(item.ackTimer);
        this.reliableActions.delete(actionId);
    }
    clearReliableActions() {
        for (const actionId of Array.from(this.reliableActions.keys()))this.forgetReliableAction(actionId);
    }
    onMessage(message) {
        switch(message.type){
            case 'JOINED':
                this.localPlayerId = message.playerId;
                (0, $crvyM.storePlayerId)(message.playerId);
                this.game = {
                    gameId: message.gameId,
                    playerId: message.playerId,
                    authoritative: !!message.authoritative
                };
                this.events.emit('connect', this.game, message.isFirst);
                this.awaitingFullSync = true;
                this.setConnectionState('synchronizing');
                break;
            case 'UPDATE':
                this.events.emit('update', message.entries, message.full);
                if (message.full && this.awaitingFullSync) {
                    this.awaitingFullSync = false;
                    this.resendReliableActions();
                }
                break;
            case 'HEARTBEAT_ACK':
                if (message.nonce === this.heartbeatNonce) {
                    this.heartbeatNonce = null;
                    this.heartbeatSentAt = 0;
                }
                break;
            case 'ERROR':
                this.events.emit('serverError', message.error);
                break;
            case 'ACTION_ACK':
                {
                    this.forgetReliableAction(message.actionId);
                    const item = this.actionDiagnostics.get(message.actionId);
                    if (item) {
                        item.ackAt = $38167fb08b74ea59$var$diagnosticNow();
                        item.ackOk = message.ok;
                        $38167fb08b74ea59$var$logDiagnostic('action.ack', {
                            actionId: message.actionId,
                            actionKind: item.actionKind,
                            ok: message.ok,
                            sendToAckMs: $38167fb08b74ea59$var$roundedMs(item.ackAt - item.sentAt)
                        });
                        if (!message.ok || item.renderedAt !== undefined) this.actionDiagnostics.delete(message.actionId);
                    }
                }
                this.events.emit('actionAck', message);
                if (this.connectionStateValue === 'recovering' && this.reliableActions.size === 0) this.setConnectionState('ready');
                break;
            case 'FRIEND_CONFIG_SET_ACK':
                this.events.emit('friendConfigSetAck', message);
                break;
            case 'BLOOD_CONFIG_SET_ACK':
                this.events.emit('bloodConfigSetAck', message);
                break;
            case 'GUOBIAO_CONFIG_SET_ACK':
                this.events.emit('guobiaoConfigSetAck', message);
                break;
            case 'AI_TEMPLATES':
                this.events.emit('aiTemplates', message);
                break;
            case 'AI_TEMPLATE_SAVED':
                this.events.emit('aiTemplateSaved', message);
                break;
            case 'AI_TEMPLATE_DELETED':
                this.events.emit('aiTemplateDeleted', message);
                break;
            case 'AI_TEMPLATE_DEFAULT_SET':
                this.events.emit('aiTemplateDefaultSet', message);
                break;
            case 'AI_HISTORY':
                this.events.emit('aiHistory', message);
                break;
            case 'AI_PREVIEW':
                this.events.emit('aiPreview', message);
                break;
            case 'AI_DELTA':
                this.events.emit('aiDelta', message);
                break;
            case 'AI_RESULT':
                this.events.emit('aiResult', message);
                break;
            case 'AI_ERROR':
                this.events.emit('aiError', message);
                break;
        }
    }
}

});
parcelRegister("crvyM", function(module, exports) {

$parcel$export(module.exports, "storePlayerId", () => $9a42339774961e01$export$8a2d9d9bfeb2baba);
$parcel$export(module.exports, "getOrCreatePlayerId", () => $9a42339774961e01$export$94f87c28e0ebadf8);
const $9a42339774961e01$var$STORAGE_KEY = 'mjlab.playerId';
const $9a42339774961e01$var$LEGACY_STORAGE_KEY = 'autotable.playerId';
function $9a42339774961e01$export$1cdbe48b9f77dcbe() {
    try {
        const current = localStorage.getItem($9a42339774961e01$var$STORAGE_KEY);
        if (current) return current;
        const legacy = localStorage.getItem($9a42339774961e01$var$LEGACY_STORAGE_KEY);
        if (legacy) {
            localStorage.setItem($9a42339774961e01$var$STORAGE_KEY, legacy);
            return legacy;
        }
        return null;
    } catch  {
        return null;
    }
}
function $9a42339774961e01$export$8a2d9d9bfeb2baba(playerId) {
    try {
        localStorage.setItem($9a42339774961e01$var$STORAGE_KEY, playerId);
    } catch  {
    // ignore
    }
}
function $9a42339774961e01$export$94f87c28e0ebadf8() {
    const existing = $9a42339774961e01$export$1cdbe48b9f77dcbe();
    if (existing) return existing;
    const created = $9a42339774961e01$var$generatePlayerId();
    $9a42339774961e01$export$8a2d9d9bfeb2baba(created);
    return created;
}
function $9a42339774961e01$var$generatePlayerId() {
    try {
        if (typeof crypto !== 'undefined' && 'getRandomValues' in crypto) {
            const bytes = new Uint8Array(16);
            crypto.getRandomValues(bytes);
            return Array.from(bytes).map((b)=>b.toString(16).padStart(2, '0')).join('');
        }
    } catch  {
    // ignore
    }
    // Fallback (weaker), but good enough for local-only uniqueness.
    return (Math.random().toString(16).slice(2) + Math.random().toString(16).slice(2)).slice(0, 32);
}

});




//# sourceMappingURL=mjai.690548ff.js.map
